import React, { Component } from "react";
import { string, object, bool, func, number } from 'prop-types';
import Header from "Orgs/Header";
import FooterAccountsPage from "Orgs/FooterAccountsPage";
import TermsOfUseFooter from "Orgs/TermsOfUseFooter";
import AccountsList from "./children/AccountsList";
import SupportInfo from "Molecules/SupportInfo";
import PageHeader from "Molecules/PageHeader";
import PayModalVeil from "Atoms/PayModalVeil";
import PayModalTemplate from "Templates/PayModalTemplate";
import md5 from "md5";
import axios from "axios";
import moment from "moment";


import TransactionLoader from "./transactionLoader/TransactionLoader";
import Transaction from "./transaction/Transaction";
import './AccountsPage.css';

import { MatchAccountMoreThanTwenty, NoMatchLessThanTwenty, NoMatchMoreThanTwenty } from './PaymentMessages';
import * as _ from "lodash";



let ONEINC_SCRIPT_URL,ONEINC_SESSION_URL,ONEINC_VALUE,ONEINC_GETACTIVEPOLICIES_URL;;
if(sessionStorage.getItem('app_info')){
	ONEINC_SCRIPT_URL=JSON.parse(sessionStorage.getItem('app_info')).ONEINC_SCRIPT_URL;
	ONEINC_SESSION_URL=JSON.parse(sessionStorage.getItem('app_info')).ONEINC_SESSION_URL;
	ONEINC_VALUE=JSON.parse(sessionStorage.getItem('app_info')).ONEINC_VALUE;
	ONEINC_GETACTIVEPOLICIES_URL = JSON.parse(sessionStorage.getItem('app_info')).ONEINC_GETACTIVEPOLICIES_URL;
}

export default class AccountsPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			billingAccountNumber: this.props.match.params.billing,
            zipCode: this.props.match.params.zipCode,
			showPay: false,
			messageInfoComp: <div />,
			removeAccountListing: false,
			supportInfo:false,
			successResponse:{
				currAccount:"",
				accounts:{},
				totalAmount:"",
				selectedPayMethod:[],
				account_number:"",
				date:"",
				time:"",
				transactionID:""
			},
			errorResponse:{
				code:"",
				message:"",
			}


		}
	}
	generateRandomId = (length) => {
		let mask = '';
		mask += 'abcdefghijklmnopqrstuvwxyz';
		mask += '0123456789';
		let result = '';
		for (let i = 0; i <length; i++) {
			if(i===8 || i===13 || i===18 || i===23)	result+='-';
			else result += mask[Math.floor(Math.random() * mask.length)];
		}
		return result;
	}
	todayDateFunc = (responseDate) => {
        let myDate = new Date(responseDate);
		const monthName=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
        return monthName[myDate.getMonth()]+" "+myDate.getDate()+", "+myDate.getFullYear();
    }
	
	checkoutFunc = (event) => {
		/*
		const billing_account_numbers=Object.keys(this.props.accounts);
		const updatedAccountNumbers=billing_account_numbers.filter(element=>{
			const accountValues=this.props.accounts[element];
			const accKeys=Object.keys(accountValues)
			let amountVal=+accountValues.minimum_due_amount;
			if(accKeys.includes("payment_amount")){
				amountVal=accountValues.payment_amount;
			}
			else if(accountValues.recurring_enabled && accountValues.past_due_amount===0){
				amountVal=0;
			}
			return amountVal>0;
		})

		const fields=updatedAccountNumbers.map((element,i) =>{
			const accountValues=this.props.accounts[element];
			const accKeys=Object.keys(accountValues)
			let amountVal=accountValues.minimum_due_amount;
			if(accKeys.includes("payment_amount")){
				amountVal=accountValues.payment_amount;
			}
			else if(accountValues.recurring_enabled && accountValues.past_due_amount===0){
				amountVal=0;
			}
			const index=""+(i+1);
			const key="cdf"+("0".repeat(3-index.length))+index;

			const value=`billing=${accountValues.account_number},amt=${amountVal}`;
			const obj={
				key:key,
				value:value
			}
			return obj;
		});
		
		const payload = {
			customerAccountreference: event.detail.customer_account_reference,
			amount:""+this.props.total_amount,
			token: event.detail.token,
			digiSign: event.detail.digiSign,
			custom_fields:fields,
			
			
			
		  }
		
		this.showLoadingHandler(true,false,{},false);
		
		axios({
			method: 'post',
			url: CONFIRMATION_URL,
			data: JSON.stringify(payload),
			headers: {
				'clientId':ALACRITI_VALUE,
				'Content-Type': 'application/json',
				
				'gi-trace-id':this.generateRandomId(36)
			 } 
		  })
		  .then((res) => {
			
			if("confirmationNumber" in res.data){
				const emailReceiptPayload={
					payerEmail:res.data.payer.email,
					accType:res.data.fundingAccount.accountType,
					paymentDate:this.todayDateFunc(res.data.paymentDate),
					totalAmount:res.data.amount,
					confirmationNumber:res.data.confirmationNumber,
					accountNumber:res.data.fundingAccount.accountNumber,
					customerID:res.data.payer.customerReference,
					selectedPayMethod:res.data.paymentMethod,
					accounts:this.props.accounts
				};
				
				emailReceipt(emailReceiptPayload);
			}
			
			this.showLoadingHandler(false,true,res.data,("confirmationNumber" in res.data));
			
		  })
		  .catch(err => {
			console.log(err);
			const errorMsg="It appears the issue is on our end. If you recently attempted to make a payment and have not received your confirmation number, please do not attempt another payment. Please call our customer help line 1-888-978-5371. Our team is available Mon-Fri 8 am to 8:30 pm ET. We know your time is valuable, and we apologize for the inconvenience.";
			const res={errorList:[{code:"Something's amiss",message:errorMsg}]}
			this.showLoadingHandler(false,true,res,false);
			
		  });*/
	}


	componentWillMount(){

        window.addEventListener('checkout-event',(event)=>this.checkoutFunc(event));
	}
	
	
	
	componentDidMount(){
		try{
			const title=document.getElementsByTagName('title')[0];
			title.textContent="Bill Pay/Payment Gateway";
		
			let currentAccountNumber = this.props.currentAccount.account_number
			if(currentAccountNumber){
				let customerNumber = currentAccountNumber.substring(0,10)
				let customerNumberHash = md5(customerNumber)
				global.digitalData.user.customerID = customerNumberHash;
				global.digitalData.page.error[0] = "";
			}
			
			
			this.handleRenderMobileViewToggle();
			global.digitalData.page.pageInfo.pageName = "Accounts Page";
			const tagName = 'script', script = document.createElement(tagName);
			script.src = ONEINC_SCRIPT_URL;
			script.id="orbipay-checkout-script";
			script.setAttribute("data-prevent_posting" , "true");
			script.setAttribute("data-api_event" , "create_payment");
			

			
			document.head.appendChild(script);
			window.addEventListener("resize", () => {
				if (window.innerWidth < 760) {
					this.closeBox();
				}
			});
		} catch (err){}
	}


	componentWillReceiveProps(){

		window.addEventListener("resize", this.handleRenderMobileViewToggle);
	}
	paymentConfirmation=()=>{
		window.onbeforeunload=null;
		window.location.reload(false);

	}
	handleRenderMobileViewToggle = () => {
		if (window.innerWidth < 760) {
			this.setState({
				mobileViewToggle: true
			}, () => {
				this.checkAccountCount();
			})
		} else {
			this.setState({
				mobileViewToggle: false
			}, () => {
				this.checkAccountCount();
			})
		}
	}

	checkAccountCount = () => {
		const { accountMatchBool, customerCount } = this.props;

		
		if (accountMatchBool){
			
			if(customerCount > 20){
				this.setState({
					messageInfoComp: <MatchAccountMoreThanTwenty />
				})
			}
		} else {
			

			if(customerCount < 20){
				this.setState({
					messageInfoComp: <NoMatchLessThanTwenty />
				})
			} else {
				
				this.setState({
					removeAccountListing: true,
					messageInfoComp: <NoMatchMoreThanTwenty />
				})
			}
		}
	}
	toggleSupportInfo = () =>{
		let si=!this.state.supportInfo;
		this.setState({
			...this.state,
			supportInfo:si
		});
	}
	closeBox = () =>{
		this.setState({
			...this.state,
			supportInfo:false
		});
	}
	showLoadingHandler(loadingValue,successValue,res,success){
		this.setState((prevState)=>{
			const newState={
				...prevState,
				isLoading:loadingValue,
				showSuccessfulModal:successValue,
				showOverlay:loadingValue||successValue
			}
			
			if(Object.keys(res).length!==0){
				if(success){
					let acNum=res.fundingAccount.accountNumber;
					let currentAccountNumber = this.props.currentAccount.account_number
					let customerNumber = currentAccountNumber.substring(0,10);
					let time=moment(res.timestamp,"DD-MM-YYYY HH:mm:ss A").format('h:mm A');
					time+=" ET";
					newState.successResponse={
						accounts:this.props.accounts,
						currAccount:customerNumber,
						totalAmount:res.amount,
						time:time,
						selectedPayMethod:[res.fundingAccount.accountType,res.fundingAccount.accountSubtype],
						account_number:acNum.slice(acNum.length-4),
						date:this.todayDateFunc(res.paymentDate),
						transactionID:res.confirmationNumber
					}
				}
				else{
					let errorCode=res.errorList[0].code;
					let errorMessage=res.errorList[0].message;
					newState.errorResponse={
						code:errorCode,
						message:errorMessage
					}
				}
			}

			

			return newState;
			
		});
		
		
	}

	hidePayModal = () => {
    this.props.hidePayModal();
	}

	fetchSessionId = async() => {
		this.showLoadingHandler(true,false,{},false);
		try {
			const response = await axios.get(ONEINC_SESSION_URL, {
				headers: {
					'Accept': 'application/json',
					'Ocp-Apim-Subscription-Key': ONEINC_VALUE
				}
			});
	
			// Assuming the API returns a JSON object with sessionId and accessTokenId
			if (response.status === 200) {
				console.log(response.data.portalOneSessionKey);
				this.showLoadingHandler(false,false,{},false);

				return {
					sessionId: response.data.portalOneSessionKey,
				};
			} else {
				console.error('Failed to fetch session ID, status:', response.status);
				return null;
			}
		} catch (error) {
			console.error('Error fetching sessionId:', error);
			return null;
		}
	}

	//Get policydata via GetActivePolicies API
	fetchPolicyDetails = async() => {

		  this.showLoadingHandler(true,false,{},false);
		
			try {
					const accountId = this.props.currentAccount.account_number.substring(0,10).replace(" ", ""); // Get account ID
					let policiesResponse = 
						await axios.get(`${ONEINC_GETACTIVEPOLICIES_URL}/${accountId}/policies`, {
						headers: { 'Ocp-Apim-Subscription-Key':ONEINC_VALUE }
					});		
					this.showLoadingHandler(false,false,{},false);

					return (policiesResponse.data.Policies);			
					} 
					catch (error) {
					console.error("Error fetching accounts:", error);
			}
	}
				

	
	handlePaymentRouting = async(amt,accounts) => {
		//console.log(accounts);
		const sessionId = await this.fetchSessionId();  // Fetch sessionId
		if (!sessionId) {
			console.error('Unable to retrieve sessionId');
			return;
		}

		let container = document.getElementById('portalOneContainer');
		console.log(container);
		let portalOne = new OneInc.PortalOne(container, await this.subscribeToEvents()); /* global OneInc */		

		let policiesArray= await this.fetchPolicyDetails();

		_.forEach(accounts, account => {
			account.selectedPolicies = [];
			_.forEach(account.policies, policy => {
				if (!policy.paymentOption || (policy.paymentOption && policy.paymentOption !== 'No payment')) {
					account.selectedPolicies.push(policy);
				}
			})
		})
		
		const policies = Object.values(accounts)
			.filter(account =>{
				if(account.paymentOption && account.paymentOption !== 'No payment') {
					if(account.paymentOption === 'Other amount' && account.payment_amount > 0) {
						account['oneIncAmount'] = account.payment_amount;
						return true;
					} else if(account.paymentOption === 'min' && account.minimum_due_amount > 0) {
						account['oneIncAmount'] = account.minimum_due_amount;
						return true;
					} else if(account.paymentOption === 'Full payment' && account.total_payment_due > 0) {
						account['oneIncAmount'] = account.total_payment_due;
						return true;
					}
				} else {
					if(account.minimum_due_amount > 0 && !account.paymentOption) {
						account['oneIncAmount'] = account.minimum_due_amount;
						return true;
					} else if (account.payment_amount > 0 && !account.paymentOption) {
						account['oneIncAmount'] = account.payment_amount;
						return true;
					}
				}
				return false;
			})
			.map(account => ({
				'feeContext': 'PaymentWithFee',              
				'minAmountDue': account.oneIncAmount,
				'accountBalance': account.payment_amount || account.total_premium_due,           
				'clientReferenceData1': account.account_number,      
				'clientReferenceData2': 'INHO',   
				'clientReferenceData3': '',      
				'accountGroupCode': 'Default' ,       
				'finalPayDate': account.last_payment_date,
				'selectedPolicies':account.selectedPolicies
			}));
			if(policies.length!==0)
				{	
					policies.forEach(policy => {
						let key=policy.clientReferenceData1;
						if(policiesArray.find(item => Object.values(item).includes(key)))
							{
								let finalPaymentAmountGroups = [];
								let result=policiesArray.find(item => Object.values(item).includes(key));
								if(result!==undefined || result!==null){policy.clientReferenceData3=result.PolicyDetails.Properties.ClientReferenceData3;}

							if (policy.selectedPolicies.length > 0) {
								result.PaymentAmountGroups.forEach(group => {
									let pnum = group.PaymentAmountKey.split(',');

									policy.selectedPolicies.forEach(spolicy => {
										if (spolicy.policy_number === pnum[0] && spolicy.policyTermId === pnum[1]) {
											finalPaymentAmountGroups.push(group);
										}
									})
								})
							}

							 policy.paymentAmountGroups = finalPaymentAmountGroups.map(group => ({
									'paymentAmountKey': group.PaymentAmountKey,
                					'displayName': group.DisplayName,
									'minimumAmountDue': Number(group.MinimumAmountDue),
									'remainingBalance': Number(group.RemainingBalance),
									'otherAmountAllowed': true
								}));
								
							}
							else{policy.minAmountDue='0.00';policy.accountBalance='0.00'}
	
					});				
				}
			portalOne.makePayment({
				'operation': 'makePayment',
				'feeContext': 'PaymentWithFee',
				'amountContext': 'amountDueOnly',
				'confirmationDisplay': true,
				'acceptCreditCards': true,
				'acceptPrepaidCards': true,
				'loadingIndication': true,
				'preventBackgroundScroll': false,
				//'billingZip': accounts[Object.keys(accounts)[0]].zip_code,
				'billingZip': '',
				'billingAddressStreet': '',
				'acknowledgmentRequired': true,
				'paymentCategory': 'UserSelect',                  
				'saveOption': 'DoNotSave',
				'sessionId': sessionId.sessionId,  
				'policies': policies
			});
			console.log(policies, 'policiesSentToOneInc');
			container.addEventListener("portalOne.unload", function() {
				//window.location.href = "/index";
				window.onbeforeunload = null;
				//window.location.reload();
				});
		
	}

	
	subscribeToEvents = async(container) => {
		if (!container) {
			return;
		  }
		  container.addEventListener("portalOne.load", function() {
			console.log("load");
			});
		  container.addEventListener("portalOne.unload", function() {
			console.log("Close OneInc Modal"); 
			});
	}



	componentWillUnmount = () => {
		window.removeEventListener("resize", this.handleRenderMobileViewToggle);
	}

	cssClasses = (showPayVeil,showModal) =>{
		let classes="";

		if(showPayVeil){
            classes = " payselect-is-open";
		} else {
            if (showModal) {
                classes = " paymodal-is-open";
            } else {
                classes = " paymodal-is-closed";
            }
        }
		return classes;
	}
	check = (conditions) => {
		return (conditions)	? true : false;
	}

	render() {
		const { accounts,
			openPayModalFunc,
			showModal,
			showPayModalFunc,
			showPayVeil,
			showPayVeilFunc,
			hidePayVeilFunc,
		 	total_amount
		 } = this.props;

		const { messageInfoComp, removeAccountListing, mobileViewToggle } = this.state;
		
		
		let classes=this.cssClasses(this.props.showPayVeil,this.props.showModal);

		
		let disabledToggle = this.check(total_amount < 0.01);

		return (

			<div className={"AccountsPage " + classes}>
				<PayModalVeil />



				{this.props.showModal ? <PayModalTemplate close={this.hidePayModal}/> : <div />}
				<div className="accounts-page-contents">

				<div className="masthead">
					<Header toggleBox={this.toggleSupportInfo} closeBox={this.closeBox}/>
					{this.state.supportInfo && <div className="infoBox support-info-is-visible">
						<SupportInfo closeBox={this.toggleSupportInfo}/>
					</div>}
					<PageHeader
						title="Bill pay"
						subtitle="Choose the amount you want to pay for each account."
						/>
					</div>
					

					{ messageInfoComp }


					<div className="site-main">
					<main>
						<div className="billing-accounts-area">
							<div className="dx-col">

							
								{ removeAccountListing ?
									<div /> :
									<div>
										<div className="area-header">{" "}Billing Accounts{" "}</div>
									  	<div className="area-content">
											<AccountsList
												accounts={accounts}
												openPayModalFunc={openPayModalFunc}
												showModal={showModal}
												showPayVeil={showPayVeil}
												showPayModalFunc={showPayModalFunc}
												showPayVeilFunc={showPayVeilFunc}
												hidePayVeilFunc={hidePayVeilFunc}
												total_amount={total_amount}
												mobileViewToggle={mobileViewToggle}
												currentAccount={this.props.currentAccount}

											/>
											
											<button id="orbipay-checkout-button" style={{display:"none"}}></button>
											 {(this.state.showOverlay) &&
											 	<div id="overlay_modal" >
												{this.state.isLoading && <TransactionLoader />}
												{this.state.errorResponse.code.length===0 && <Transaction pcgx={this.props.pcgx} transInfo={this.state.successResponse} onClickHandler={this.paymentConfirmation.bind(this)}/>}
												{this.state.errorResponse.code.length!==0 && <Transaction pcgx={this.props.pcgx} transInfo={this.state.errorResponse} onClickHandler={this.paymentConfirmation.bind(this)}/>}
											</div>}
											 

											<div className="billing-accounts-buttons">
												<button className="primary" onClick={()=>
													{
													this.handlePaymentRouting(total_amount,accounts)}} 
												disabled={disabledToggle}>
													Next
												</button>
											</div>

										</div>
									</div>									

							}
							
							</div>
						</div>
						</main>
					<div className="footer-AccountsPage">
						<FooterAccountsPage />
					</div>

					</div>
					
				</div>
			  <TermsOfUseFooter/>
			  {window.innerWidth<760 && <div className="infoBox support-info-is-hidden">
					<SupportInfo mobile={true}/>
					</div>}
			</div>
		);
	}
}

AccountsPage.propTypes = {
	showPay: bool,
	error: bool,
	message: string,
	submitHandler: func,
	accounts: object,
	openPayModalFunc: func,
	showModal: bool,
	showPayModalFunc: func,
	showPayVeil: bool,
	showPayVeilFunc: func,
	hidePayVeilFunc: func,
	total_amount: number,
}



// WEBPACK FOOTER //
// ./src/components/atomic/pages/AccountsPage/AccountsPage.js